import { useContext } from 'react';

import {
  useLocation as useLocationReactRouter,
  useNavigate as useNavigateReactRouter,
} from 'react-router-dom';

import { RouterContext } from './router.provider';

const useRouter = () => {
  const context = useContext(RouterContext);
  if (context === undefined) {
    return {
      useNavigate: useNavigateReactRouter,
      useLocation: useLocationReactRouter,
    };
  }
  const { useNavigate, basePath, useLocation: useLocationContext } = context;
  return { useNavigate, basePath, useLocation: useLocationContext ?? useLocationReactRouter };
};
export { useRouter };
